import styles from './TotalObjects.module.css';
import cn from 'classnames';

interface TotalObjectsProps {
  buttonColor: string;
  objectLength: number;
  onClick?: () => void;
}

const getObjectLabel = (count: number): string => {
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;

  if (lastDigit === 1 && lastTwoDigits !== 11) {
    return `${count} объект`;
  } else if ((lastDigit >= 2 && lastDigit <= 4) && (lastTwoDigits < 12 || lastTwoDigits > 14)) {
    return `${count} объекта`;
  } else {
    return `${count} объектов`;
  }
};

export default function TotalObjects({ objectLength, buttonColor, onClick }: TotalObjectsProps) {
  return (
    <div className={styles.objects}>
      <p className='text_subheaders_sh2'>{getObjectLabel(objectLength)}</p>
      <button className={cn('text_subheaders_sh2', styles.button, styles[buttonColor])} onClick={onClick}>
        Очистить
      </button>
    </div>
  );
}
